import { render, staticRenderFns } from "./_comment.vue?vue&type=template&id=3cb9ef2e"
import script from "./_comment.vue?vue&type=script&lang=js"
export * from "./_comment.vue?vue&type=script&lang=js"
import style0 from "./_comment.vue?vue&type=style&index=0&id=3cb9ef2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports